export default __webpack_public_path__ + "static/media/border-vertical-2.5c6c12c5.png";